import { useEffect, useState } from 'react';

import { useUrlPreviewContext } from '@lyearn/lygo-core';

// If icon from the URL is small than this width, it wil not
// look good in the URL preview.
const MAX_ICON_WIDTH = 154;

export const usePreview = (localUrl: string, options?: Object) => {
  const { useUrlPreviewsQuery } = useUrlPreviewContext();
  const [preview, setPreview] = useState({});
  const [{ data, error, fetching }] = useUrlPreviewsQuery({
    variables: {
      input: {
        urls: [localUrl],
      },
    },
    ...options,
  });

  useEffect(() => {
    const urlPreview = data?.urlPreviews?.previews?.[0];
    if (urlPreview) {
      setPreview({
        title: urlPreview.title,
        url: urlPreview.url,
        desc: urlPreview.description,
        img: urlPreview.icon && urlPreview.icon.width > MAX_ICON_WIDTH ? urlPreview.icon.url : '',
        coverImg: urlPreview.image?.url ?? '',
      });
    } else if (data && data.urlPreviews) {
      let title;
      try {
        title = new URL(localUrl).hostname;
      } catch (e) {
        title = localUrl;
      }
      setPreview({
        title,
        url: localUrl,
      });
    }
  }, [data, localUrl]);

  return { fetching, preview, error };
};
